<template>
  <div class="sorttable">
    <div
      ref="caozuo"
      style="
        display: flex;
        justify-content: space-between;
        line-height: 40px;
        margin-bottom: 10px;
      "
    >
      <div>
        <el-button size="small" @click="shuaxin">
          <i class="el-icon-refresh-right"></i> 刷新
        </el-button>
        <el-button size="small" @click="popDialog(1)">
          <i class="el-icon-plus"></i> 批量导入授权数
        </el-button>
        <el-button size="small" @click="popDialog(2)">
          <i class="el-icon-plus"></i> 批量修改代理商
        </el-button>
        <ExportExcel
          :E_ids="E_ids"
          :E_condition="E_condition"
          :E_dataLength="E_dataLength"
          :E_methodname="E_methodname"
          :E_searchArr="E_searchArr"
        ></ExportExcel>
        <!-- <el-button size="small" @click="dialogFormVisible">
        <i class="el-icon-plus"></i> 新增
      </el-button>
      <el-button size="small" @click="daoru">
        <i class="el-icon-plus"></i> 批量导入
      </el-button> -->
      </div>

      <div style="display: flex">
        <div class="searchItem" style="border-bottom: none; margin-right: 25px">
          <div class="searchInfo">
            <el-form
              :model="ruleForm"
              ref="ruleForm"
              label-width="100px"
              class="demo-ruleForm"
              style="height: 40px"
            >
              <el-form-item label="话费余额" prop="money_type">
                <el-radio-group
                  v-model="ruleForm.money_type"
                  @change="changeresource"
                >
                  <el-radio :label="0">全部</el-radio>
                  <el-radio :label="1">2元以上</el-radio>
                  <el-radio :label="2">2元以下</el-radio>
                  <el-radio :label="3">自定义</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-form>
            <div
              v-show="ruleForm.money_type == 3"
              class="searchInfo"
              style="margin-left: -43px; display: flex"
            >
              <div class="searchInput">
                <input
                  type="text"
                  name="points"
                  v-model="s_money"
                  maxlength="10"
                  oninput="javascript:this.value=this.value.replace(/[^\d]/g,'')"
                />
                <span class="searchInputIcon">-</span>
                <input
                  type="text"
                  name="points"
                  v-model="e_money"
                  maxlength="10"
                  oninput="javascript:this.value=this.value.replace(/[^\d]/g,'')"
                />
              </div>
              <span class="searchInputDesc">元</span>
              <el-button size="small" @click="changeMoney">确定</el-button>
            </div>
          </div>
        </div>

        <ProjectSearch ref="searchform" :fields="steps" />
      </div>
    </div>

    <el-table
      :height="zhanshi"
      :data="tableData"
      style="width: 100%"
      :header-cell-style="headerCellStyle"
      @selection-change="handleSelectionChange"
      :cell-style="cellStyle"
      ref="multipleTable"
    >
      <el-table-column type="selection"></el-table-column>
      <el-table-column prop="name" label="用户名" width="150"></el-table-column>
      <el-table-column
        prop="mobile"
        label="手机号码"
        width="160"
      ></el-table-column>
      <el-table-column prop="status" label="状态" width="60">
        <template slot-scope="scope">
          <div style="color: #f5826c" v-if="scope.row.status == 0">禁用</div>
          <div style="color: #95c23a" v-else>启用</div>
        </template>
      </el-table-column>
      <el-table-column prop="status" label="审核状态" width="100">
        <template slot-scope="scope">
          <span v-if="scope.row.status_review == 0"> 未审核 </span>
          <span v-else-if="scope.row.status_review == 1" style="color: #95c23a">
            通过审核
          </span>
          <span v-else-if="scope.row.status_review == 2" style="color: #f5826c">
            未通过
          </span>
          <span v-else>--</span>
        </template>
      </el-table-column>
      <el-table-column prop="label" label="企业" width="120">
        <template slot-scope="scope">
          <span v-if="scope.row.CompanyInfo.name" style="color: #359746">
            {{ scope.row.CompanyInfo.name }}
          </span>
          <span v-else>--</span>
        </template>
      </el-table-column>
      <el-table-column prop="is_open_recording" label="录音开关" width="100">
        <template slot-scope="scope">
          <div style="color: #f5826c" v-if="scope.row.is_open_recording == 0">
            关闭
          </div>
          <div style="color: #95c23a" v-else>开启</div></template
        >
      </el-table-column>
      <el-table-column prop="iccid" label="iccid" width="110" />
      <el-table-column prop="created_at" label="创建时间" width="180" sortable>
      </el-table-column>
      <el-table-column prop="operate_name" label="运营商" width="100" sortable>
        <template slot-scope="scope">
          <span>
            {{ scope.row.IccidInfo.operator_name || "" }}
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="package_type" label="套餐类型" width="80">
        <template slot-scope="scope">
          <span>
            {{ scope.row.PackageTypeInfo && scope.row.PackageTypeInfo.name }}
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="money" label="余额" width="160">
        <template slot-scope="scope">
          <span v-if="scope.row.money < 2" style="color: red">
            ￥
            {{ scope.row.money }}
          </span>
          <span v-else>
            ￥
            {{ scope.row.money }}
          </span>
          <span @click.stop="searchMoney(scope.row)" style="cursor: pointer">
            <i class="el-icon-refresh"></i>
          </span>
        </template>
      </el-table-column>
      <el-table-column
        prop="app_expiration_time"
        label="APP授权到期时间"
        width="180"
      >
      </el-table-column>
      <el-table-column prop="user" label="归属代理商" width="160">
        <template slot-scope="scope">
          <span v-if="scope.row.parentUserInfo.name" style="color: #359746">
            {{ scope.row.parentUserInfo.name }}
          </span>
          <span v-else>暂无</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="last_login_time"
        label="最后登录时间"
        width="180"
        sortable
      >
      </el-table-column>
      <el-table-column
        prop="login_ip"
        label="登录IP"
        width="150"
      ></el-table-column>
      <el-table-column label="操作" fixed="right" width="180">
        <template slot-scope="scope">
          <div>
            <el-link
              type="primary"
              v-show="scope.row.is_direct_son == 1"
              @click="Recharge(scope.row)"
              >充值
            </el-link>
            <span class="activespan" v-show="scope.row.is_direct_son == 1">
              |
            </span>
            <el-link type="primary" @click="handleEdit(scope.row)"
              >编辑
            </el-link>
            <span class="activespan">|</span>
            <el-link
              type="danger"
              v-if="scope.row.status == 1"
              @click="handleDisable(scope.row)"
              >账号禁用
            </el-link>
            <el-link type="primary" v-else @click="handleDisable(scope.row)"
              >账号启用
            </el-link>
            <!-- <span class="activespan">|</span>
            <el-link type="primary" @click="onReset(scope.row)"
              >重置密码
            </el-link> -->
            <!-- <el-link
              type="primary"
              @click.native.stop="handleDelete(scope.$index, scope.row)"
              >删除
            </el-link> -->
          </div>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <el-pagination
      class="pagination_bottom"
      background
      layout="total,sizes, prev, pager, next"
      :page-sizes="[20, 50, 100, 200, 300, 400]"
      @size-change="handleSizeChange"
      :total="total"
      :page-size="pagesize"
      @current-change="current_change"
      :current-page="currentPage"
    ></el-pagination>
    <!-- 新增弹出层 -->
    <el-dialog
      :title="title"
      :visible.sync="dialogaddVisible"
      :destroy-on-close="true"
      width="600px"
      class="dialogbox"
    >
      <el-form :model="form1" ref="form1" :rules="ruleForm1">
        <div v-if="this.title == '新增'">
          <el-form-item prop="iccid" label="ICCID">
            <el-input v-model="form1.iccid"></el-input>
          </el-form-item>
        </div>
        <div v-else>
          <el-form-item prop="name" label="姓名">
            <el-input v-model="form1.name"></el-input>
          </el-form-item>
          <el-form-item prop="iccid" label="ICCID">
            <el-input v-model="form1.iccid" disabled></el-input>
          </el-form-item>
          <el-form-item prop="mobile" label="手机号码">
            <el-input v-model="form1.mobile" disabled></el-input>
          </el-form-item>
          <!-- <el-form-item prop="status" label="帐号状态">
            <el-radio-group v-model="form1.status">
              <el-radio :label="1">启用</el-radio>
              <el-radio :label="0">禁用</el-radio>
            </el-radio-group>
          </el-form-item> -->
          <el-form-item prop="is_open_recording" label="录音开关">
            <el-radio-group v-model="form1.is_open_recording">
              <el-radio :label="1">启用</el-radio>
              <el-radio :label="0">禁用</el-radio>
            </el-radio-group>
          </el-form-item>
          <!-- <el-form-item prop="label" label="标签：">
            <el-input v-model="form1.label"></el-input>
          </el-form-item> -->
        </div>
        <!-- <el-form-item label="备注">
          <el-input type="textarea" v-model="form1.desc"></el-input>
        </el-form-item> -->
        <el-form-item
          style="width: 95%; display: flex; justify-content: flex-end"
        >
          <el-button v-if="form1.id" type="primary" @click="editdata('form1')"
            >确定</el-button
          >
          <el-button v-else type="primary" @click="onSubmit('form1')"
            >确定</el-button
          >
          <el-button @click="dialogaddVisible = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- 新增弹出层 -->
    <!-- 导入弹出层 -->
    <el-dialog
      title="导入"
      :visible.sync="dialogDaoruVisible"
      :destroy-on-close="true"
      width="500px"
      class="dialogbox"
    >
      <el-form :model="form2" ref="ruleForm2" label-width="80px">
        <el-form-item label="上传文件">
          <el-upload
            class="upload-demo"
            :action="this.hostName + '/UserController/ImportFileAction'"
            :on-success="handleSuccess"
            :on-error="handleError"
            :before-remove="beforeRemove"
            :before-upload="beforeUpload"
            multiple
            :limit="1"
            :on-exceed="handleExceed"
            :file-list="fileList"
            :auto-upload="true"
          >
            <el-button size="small" type="primary">点击上传</el-button>
          </el-upload>
        </el-form-item>
        <el-form-item label="导入模板">
          <span style="color: #26a7ff; cursor: pointer" @click="down"
            >点击下载模板</span
          >
        </el-form-item>
        <el-form-item label="说明">
          <span>每次导上限为3000条导入大量数据的情况下，请分批导入</span>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="ondaoru">导入</el-button>
          <el-button @click="dialogDaoruVisible = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- 导入弹出层 -->
    <el-dialog
      title="重置密码"
      :destroy-on-close="true"
      width="500px"
      :visible.sync="DialogPasswordVisible"
    >
      <span>是否重置密码，该操作不可恢复！</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="DialogPasswordVisible = false">取 消</el-button>
        <el-button type="primary" @click="Resetpassword">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 授权弹出层 -->
    <el-dialog
      title="充值授权"
      :visible.sync="dialogDistributeVisible"
      width="600px"
    >
      <el-form :rules="rules" ref="form" :model="form">
        <el-form-item label="授权商品:" label-width="180px">
          <span class="el-span">{{ shopData.callTypeInfo.card || "" }}</span>
        </el-form-item>
        <el-form-item label="充值对象:" label-width="180px">
          <span class="el-span">{{ row.name }}</span>
        </el-form-item>
        <el-form-item label="剩余可充值数量:" label-width="180px">
          <span class="el-span">{{ shopData.sum - shopData.use }}个</span>
        </el-form-item>
        <el-form-item label="APP授权数:" label-width="180px" prop="num">
          <el-input
            v-model="form.num"
            style="width: 270px"
            placeholder="请输入"
            @input="changeNumber"
            onkeyup="value=value.replace(/[^\d]/g,'').replace(/^0{1,}/g,'')"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogDistributeVisible = false">取 消</el-button>
        <el-button type="primary" @click="onDistribute('form')"
          >确 定</el-button
        >
      </div>
    </el-dialog>
    <el-dialog :title="popType==1 ? '批量充值授权对象' : '批量修改代理商'" :visible.sync="showImport" width="600px">
      <div v-if="popType==1" style="margin-bottom:10px">授权商品：话机智能卡</div>
      <div class="dialogTips">
        <p class="dialogTipsText">
          1.<span style="color: #26a7ff; cursor: pointer" @click="downloadTemplate"
            >点击下载模板</span
          >
        </p>
        <p class="dialogTipsText">2.将要导入的客户数据填写到模板文件中</p>
        <p class="dialogTipsText">3.模板中表头不可更改,不可删除</p>
        <p class="dialogTipsText">
          4.每次导入上限为1000条,导入大量数据的情况下,请分批导入
        </p>
      </div>
      <el-form class="dialogForm">
        <el-form-item label-width="100px" label="上传文件：">
          <el-upload
            action="#"
            accept=".xlsx"
            :limit="1"
            :file-list="batchFileList"
            :on-change="changeFile"
            :on-remove="changeRemove"
            :auto-upload="false"
          >
            <el-button icon="el-icon-download" size="small" type="primary"
              >上传文件</el-button
            >
          </el-upload>
        </el-form-item>     
        <el-form-item v-if="popType==2" label="所属代理商：" label-width="100px" style="width: 60%">
          <el-select v-model="agent" size="small" filterable style="width: 100%">
            <el-option v-for="item in agentList" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="onClose">取 消</el-button>
        <el-button type="primary" @click="onBatchSubmit">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { postData, getData } from "@/api/index";
import { height1 } from "@/utils/height";
import {
  getCheckBalanceAction,
  getACPageAction,
} from "@/services/server/AccountInterface";
import axios from "axios";
import { debounce } from "@/utils/tool.js";
import ExportExcel from "@/components/ExportExcel";
import ProjectSearch from "@/components/ProjectSearch.vue";
import { ElectricSearch } from "@/config/accountSearch";
import { getDirectSonAction } from "@/services/server/publicInterface";

export default {
  components: {
    ExportExcel,
    ProjectSearch,
  },
  data() {
    // 设置手机号的验证规则
    var phoneRules = (rule, value, callback) => {
      const reg = /^1[3|4|5|6|7|8|9][0-9]\d{8}$/;
      if (reg.test(value)) {
        callback();
      } else {
        return callback(new Error("请输入正确的电话"));
      }
    };
    return {
      E_ids: [], //选中id
      E_condition: {}, //条件
      E_dataLength: 0, //数据长度
      E_searchArr: ["name", "mobile", "operator_id"], //搜索条件过滤
      E_methodname: "agent_user", //方法名
      zhanshi: "800px",
      formLabelWidth: "130px",
      select: "2",
      agent: [],
      android_os: [],
      brand: [],
      mobile_type: [],
      version: [],
      // 文件
      tableData: [],
      total: 0, //默认数据总数
      pagesize: 20, //每页的数据条数
      currentPage: 1, //默认开始页面
      value2: "",
      formes: {
        keywords: "",
      },
      rules: {
        num: [
          { required: true, message: "请输入APP授权数量", trigger: "blur" },
        ],
      },
      title: "",
      form: {
        num: "",
      },
      form1: {
        name: "",
        mobile: "",
        status: 1,
        iccid: "",
        is_open_recording: 1,
        desc: "",
      },
      form2: {
        file: "",
        portal_id: "",
        company_id: "",
      },
      shopData: {
        callTypeInfo: { card: "" },
      },
      token: "",
      fileList: [],
      formData: new FormData(),
      dialogaddVisible: false,
      dialogDaoruVisible: false,
      ruleForm1: {
        name: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        iccid: [{ required: true, message: "请输入ICCID", trigger: "blur" }],
        mobile: [
          { required: true, message: "请输入电话号码", trigger: "blur" },
          { validator: phoneRules, trigger: "blur" },
        ],
        status: [
          { required: true, message: "请选择账号状态", trigger: "blur" },
        ],
        is_open_recording: [
          { required: true, message: "请选择录音开关状态", trigger: "blur" },
        ],
      },
      DialogPasswordVisible: false,
      dialogDistributeVisible: false,
      selectId: 0,
      row: {},
      call_type_id: 101,
      steps: [],
      ruleForm: {
        money_type: 0,
      },
      s_money: "",
      e_money: "",
      agent: '',
      showImport: false,
      importData: {
        file: "",
      },
      batchFileList: [],
      apiHost: "",
      popType:'',
      agentList:[]
    };
  },
  async created() {
    await this.$fetchDicByField("OperatorArr");
    this.steps = ElectricSearch;
    this.getMainData();
    this.getMenuList();
    this.getAgentList()
    this.apiHost = localStorage.getItem("service_cname");
    this.uploadUrl = `${this.apiHost}agent/call.CallSeatController/importCommonAction`;
    this.uploadUrl2 = `${this.apiHost}agent/UserController/dlsUpdateMoreImportAction`;
  },
  mounted() {
    setTimeout(() => {
      var H = document.body.clientHeight;
      this.zhanshi = H - height1 - 10;
    }, 100);
    const that = this;
    window.onresize = () => {
      var H = document.body.clientHeight;
      that.zhanshi = H - height1 - 10;
    };
  },
  methods: {
    async getAgentList() {
      let res = await getDirectSonAction({ page: 1, pagesize: 999 });
      this.agentList = res;
    },
    popDialog(type){
      this.popType = type
      this.showImport = true
    },
    downloadTemplate(){
      if(this.popType==1){
        getData("call.CallSeatController/demoAction").then((res) => {
          if (res.code !== 200) return this.$message.error(res.message);
          window.location.href = res.data;
        });
      }else{
        getData("company.CompanyUserController/demoAction").then((res) => {
          if (res.code !== 200) return this.$message.error(res.message);
          window.location.href = res.data;
        });
      }
    },
    onClose() {
      this.showImport = false;
      this.importData.file = "";
      this.batchFileList = [];
    },
    changeFile(file) {
      this.importData.file = file.raw;
    },
    changeRemove() {
      this.importData.file = "";
    },
    async onBatchSubmit() {
      if (this.importData.file) {
        const formData = new FormData();
        formData.append('file',this.importData.file)
        this.popType == 1 ? formData.append('call_type_id',this.call_type_id) : ''
        this.popType == 2 ? formData.append('parent_id',this.agent) : ''
        const res = await axios.post(this.popType == 1 ? this.uploadUrl : this.uploadUrl2, formData, {
          headers: {
            token: sessionStorage.getItem("token"),
            "Content-Type": "multipart/form-data",
          },
        });
        if (res.data.code === 200) {
          this.onClose();
          this.$message.success("导入成功");
          this.esarchang();
        } else {
          this.$message.error(res.data.message);
        }
      } else {
        return this.$message.warning("请选择要导入的文件");
      }
    },
    async searchMoney(row) {
      let res = await getCheckBalanceAction({
        user_id: row.id,
        mobile: row.mobile,
      });
      if (res.code !== 200) return this.$message.error(res.message);
      for (let i of this.tableData) {
        if (i.id == row.id) {
          row.money = res.data;
        }
      }
      this.$message.success("余额刷新成功");
    },
    changeresource() {
      if (this.ruleForm.money_type !== 3) {
        this.s_money = "";
        this.e_money = "";
        this.esarchang(1);
      }
    },
    changeMoney() {
      this.esarchang(1);
    },
    handleDisable(row) {
      this.$confirm(
        `正在${!row.status ? "启用" : "禁用"}账号${row.name}, 是否继续？`,
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(() => {
          postData("UserController/disabledUserAction", {
            id: row.id,
            status: Number(!row.status),
          }).then((res) => {
            if (res.code !== 200) return this.$message.error(res.message);
            this.$message.success(`${!row.status ? "启用" : "禁用"}成功`);
            this.esarchang();
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
    handleSelectionChange(val) {
      this.E_ids = [];
      val.forEach((i) => {
        this.E_ids.push(i.id);
      });
    },

    changeNumber() {
      if (this.form.num >= this.shopData.sum - this.shopData.use) {
        this.form.num = this.shopData.sum - this.shopData.use;
      }
    },
    Recharge(row) {
      this.row = row;
      this.dialogDistributeVisible = true;
    },
    onDistribute(formName) {
      this.form.userIdStr = this.row.id;
      this.form.call_type_id = this.call_type_id;
      if (this.form.num == 0)
        return this.$message.error("充值数量必须大于等于1个");
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$confirm("确定充值授权, 是否继续?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          })
            .then(() => {
              getData(
                "call.CallSeatController/setCommonAction",
                this.form
              ).then((res) => {
                if (res.code == 200) {
                  this.$message({
                    message: "充值成功",
                    type: "success",
                  });
                  this.dialogDistributeVisible = false;
                  this.$refs[formName].resetFields();
                  this.getMenuList();
                  this.esarchang();
                } else {
                  this.$message.error(res.message);
                }
              });
            })
            .catch(() => {
              this.$message({
                type: "info",
                message: "已取消",
              });
              this.form.sums = 1;
            });
        } else {
          ("error submit!!");
          return false;
        }
      });
    },
    onReset(row) {
      this.selectId = row.id;
      this.DialogPasswordVisible = true;
    },
    Resetpassword() {
      postData("UserController/initPasswordAction", { id: this.selectId }).then(
        (res) => {
          if (res.code !== 200) {
            this.$message.error(res.message);
            return true;
          }
          this.$message.success("重置密码成功");
          this.DialogPasswordVisible = false;
          this.esarchang();
        }
      );
    },
    // 下载导入模板
    down() {
      getData("UserController/demoAction").then((res) => {
        if (res.code !== 200) return this.$message.error(res.message);
        window.location.href = res.data;
      });
    },
    // 导入提交
    ondaoru() {
      if (this.formData.get("file") !== null) {
        let formData = new FormData();
        formData.append("file", this.formData.get("file"));
        axios
          .post(
            localStorage.getItem("service_cname") +
              "/agent" +
              "/UserController/ImportFileAction",
            formData,
            {
              headers: {
                "Content-Type": "multipart/form-data",
                token: sessionStorage.getItem("token"),
              },
            }
          )
          .then(({ data: res }) => {
            if (res.code !== 200) return this.$message.error(res.message);
            if (res.code == 200) {
              this.dialogDaoruVisible = false;
              this.$message.success("导入成功");
              this.esarchang();
            }
          });
      } else {
        this.$message({
          message: "请导入文件后提交",
          type: "error",
        });
      }
    },
    daoru() {
      this.dialogDaoruVisible = true;
    },
    //上传文件前的钩子
    beforeUpload(file) {
      this.formData.append("file", file);
    },
    // 上传成功
    handleSuccess(files) {
      this.form2.file = files.data.src;
    },
    // 上传失败
    handleError(files, fileList) {
      console.log(files, fileList);
    },
    // 数量超
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${
          files.length + fileList.length
        } 个文件`
      );
    },
    //移除之前的钩子，清空所有文件
    beforeRemove() {
      this.formData = new FormData();
    },
    handleEdit(row) {
      this.title = "编辑";
      this.dialogaddVisible = true;
      let { id, name, mobile, iccid, status, is_open_recording, desc } = row;
      this.form1 = {
        id,
        name,
        iccid,
        mobile,
        status,
        is_open_recording,
        desc,
      };
    },
    onSubmit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          postData("UserController/addAction", this.form1).then((res) => {
            if (res.code == 200) {
              this.$message.success("新增成功");
              this.dialogaddVisible = false;
              this.close(formName);
              this.esarchang();
            } else {
              this.$message.error(res.message);
            }
          });
        } else {
          return false;
        }
      });
    },
    editdata(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          postData("UserController/updateAction", this.form1).then((res) => {
            if (res.code == 200) {
              this.$message.success("修改成功");
              this.dialogaddVisible = false;
              this.close(formName);
              this.esarchang();
            } else {
              this.$message.error(res.message);
            }
          });
        } else {
          return false;
        }
      });
    },
    close(formName) {
      this.dialogaddVisible = false;
      this.dialogDaoruVisible = false;
      this.$refs[formName].resetFields();
      this.esarchang();
    },
    //刷新
    shuaxin() {
      this.ruleForm.money_type = 0;
      this.s_money = "";
      this.e_money = "";
      this.$refs.searchform.onready();
      this.esarchang(1);
      this.$message({ message: "刷新成功", type: "success" });
    },
    // 获取数据
    async getMainData(
      params = {
        page: this.currentPage,
        role: 3,
        call_type_id: this.call_type_id,
        pagesize: this.pagesize,
      }
    ) {
      this.E_condition = params;
      let res = await getACPageAction(params);
      if (res.code !== 200) return this.$message.error(res.message);
      this.tableData = res.data.data || [];
      this.total = res.data.total || 0;
      this.E_dataLength = res.data.total || 0;
    },
    //搜索
    esarchang(flag) {
      if (flag) {
        this.currentPage = 1;
        this.pagesize = 20;
      }
      let formes = {
        page: this.currentPage,
        pagesize: this.pagesize,
        role: 3,
        call_type_id: this.call_type_id,
      };
      if (this.$refs.searchform.selectContent !== null) {
        formes[this.$refs.searchform.selectOption] =
          this.$refs.searchform.selectContent;
      }
      if (this.ruleForm.money_type !== 3) {
        formes.money_type = this.ruleForm.money_type;
      } else {
        formes.money_type = this.ruleForm.money_type;
        formes.s_money = this.s_money;
        formes.e_money = this.e_money;
      }
      this.E_condition = formes;
      this.getMainData(formes);
    },
    // 分页
    current_change: function (currentPage) {
      this.currentPage = currentPage;
      this.esarchang();
    },
    handleSizeChange(val) {
      this.pagesize = val;
      this.esarchang();
    },
    //新增
    dialogFormVisible() {
      this.title = "新增";
      this.dialogaddVisible = true;
    },
    //批量导入
    daoru() {
      this.dialogDaoruVisible = true;
    },
    headerCellStyle() {
      return "text-align:center;background-color:#F2f2f2;";
    },
    cellStyle() {
      return "text-align:center;";
    },
    //获取数据
    getMenuList() {
      getData(
        "call.CallSeatController/findOneAction?call_type_id=" +
          this.call_type_id
      ).then((res) => {
        if (res.code !== 200) return this.$message.error(res.message);
        this.shopData = res.data;
      });
    },
  },
  watch: {
    $route() {
      setTimeout(() => {
        var caozuo = this.$refs.caozuo.offsetHeight;
        var H = document.body.clientHeight;
        this.zhanshi = H - height1 - 10;
      }, 100);
      const that = this;
      window.onresize = () => {
        var caozuo = that.$refs.caozuo.offsetHeight;
        var H = document.body.clientHeight;
        that.zhanshi = H - height1 - 10;
      };
    },
    dialogaddVisible() {
      if (!this.dialogaddVisible) {
        this.$refs["form1"].resetFields();
      }
    },
  },
};
</script>

<style lang="less">
.el-tabs--border-card {
  border: 0;
  box-shadow: none;
}
</style>
<style lang="less" scoped>
.especially /deep/.el-input__inner {
  border-radius: 5px 0 0 5px;
  border-right: 0;
}
.especially2 /deep/.el-input__inner {
  border-radius: 0 5px 5px 0;
  border-left: 0;
}
.especially /deep/.el-input__inner:focus {
  border: 1px solid #c0c4cc;
  border-right: 0;
}
.especially2 /deep/.el-input__inner:focus {
  border: 1px solid #c0c4cc;
  border-left: 0;
}
/deep/ .el-form-item__content {
  line-height: 40px;
}
.el-container {
  display: flex;
  flex-direction: column;
}

.zrss {
  display: flex;
  .moban {
    margin-left: 10px;
    padding: 0px 20px;
    font-size: 14px;
    height: 38px;
    margin-top: 1px;
    line-height: 36px;
  }
}
</style>

<style lang="less" src="@/assets/css/dialogbox.less" scoped></style>
<style src="@/assets/css/index.css" scoped></style>;
<style lang="less" scoped>
.dialogTips {
  // width: ;
  padding: 10px;
  background: #f7f7f7;
}
.dialogForm {
  margin: 20px auto;
}
/deep/ .el-drawer.rtl,
/deep/ .el-drawer.ltr {
  top: 55px !important;
}
/deep/ .el-dialog__body{
  padding: 10px 20px;
}
</style>
